<template>
  <div class="report-filter report-errors">
    <i-switch v-model="onlyError" />
    <div class="ms-help">Только с ошибками</div>
  </div>
</template>

<script>
export default {
  computed: {
    onlyError: {
      get () {
        return this.$store.state.reports.onlyError
      },
      set (value) {
        this.$store.commit('SET_REPORTS_VALUE', {
          field: 'onlyError',
          value
        })
      }
    }
  }
}
</script>

<style lang="less">
.report-errors {
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>
